import React from "react";
import { Pie } from "react-chartjs-2";

const WorkOrderByCategory = ({ workOrderByCategory }) => {
  const colors = ["#FF5722", "#16A085", "#40A9FF", "#8E44AD"];
  const data = {
    labels: workOrderByCategory.categories.map((item) => item.categoryName && ""),
    datasets: [
      {
        data: workOrderByCategory.categories.map((item) => item.workOrders),
        backgroundColor: [
          "#FF5722", // Orange
          "#16A085", // Green
          "#40A9FF", // Blue
          "#3b2f4059", // Purple
        ],
        borderColor: "#fff",
        borderWidth: 3,
      },
    ],
  };

  const options = {
    responsive: true,
    legend: {
      display: false,
    },
  };

  return (
    <div className="work-order-card work-order-category">
      <div className="zone-wise-header">
        <div className="header wrapper-header">
          <div className="icon-wrapper">
            <i className="material-icons">description</i>
          </div>
          <div>
            <h2>Work Order By Category</h2>
          </div>
        </div>
        <div className="receipt-header">
          <span>Financial Year : {workOrderByCategory.financialYear}</span>
          <span>|</span>
          <span>ULB : {workOrderByCategory.ulbName}</span>
        </div>
      </div>

      <div className="content">
        <div className="chart-section">
          <Pie data={data} options={options} />
        </div>

        <div className="legend-section">
          {workOrderByCategory.categories.map((item, index) => {
            return (
              <div className="legend-item" key={index}>
                <div className="legend-left">
                  <span
                    className="color-box"
                    style={{
                      backgroundColor: colors[index],
                    }}
                  >
                    <i className="material-icons">receipt_long</i>
                  </span>

                  <div>
                    <h4>{item.categoryName}</h4>
                    <span>{item.workOrders} Work Orders</span>
                  </div>
                </div>
                <div className="legend-percent">{item.percentage}%</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default WorkOrderByCategory;



// WEBPACK FOOTER //
// src/modules/employee/Home/WorkOrderByCategory.js